import { PaisDTO, RegionDTO } from "@DTOS";

export namespace PaisesAcciones {
    export class Obtener {
        static readonly type = "[Paises] ObtenerTodo paises";
    }

    export class ObtenerRegiones {
        static readonly type = "[Paises] Obtener regiones";
        constructor(public pais: PaisDTO) {}
    }

    export class ObtenerCiudades {
        static readonly type = "[Paises] Obtener ciudades";
        constructor(public pais: PaisDTO, public region: RegionDTO) {}
    }

    export class ReiniciarRegiones {
        static readonly type = "[Paises] Reiniciar regiones";
    }

    export class ReiniciarCiudades {
        static readonly type = "[Paises] Reiniciar ciudades";
    }
}
